import React, {useState} from 'react'
import {pageLinks} from '../data.js'
import PageLink from './PageLink'
import menu from '../assets/lines.png'



const PageLinks = () => {
    const [showMenu, setShowMenu] = useState(false);
    return ( 
        <div style={{width: '100%'}}>
            <ul className="links-container hidden sm:flex">    
                {pageLinks.map((link) => {
                return <PageLink key={link.id} link={link}/>
                })}
            </ul>
            {showMenu &&
            <ul className={`${showMenu && 'links-container mobile pr-[15%]'} flex sm:hidden`}>    
                {pageLinks.map((link) => {
                return <PageLink key={link.id} link={link}/>
                })}
            </ul>
            }
            <img alt='' src={menu} width={36} className={` ml-auto flex sm:hidden ${showMenu ? 'mobile_menu' : 'mobile_menu rotate'}`} onClick={() => setShowMenu(!showMenu)}/>
        </div>  
    )
}

export default PageLinks